import {useState} from 'react';
import {getYouTubeVideoId} from '../utils';
import {BlockContainer} from '../styled';

type Props = {
  url?: string;
};
export const YouTubeEmbed = ({url}: Props) => {
  const [loading, setLoading] = useState(true);
  const videoId = getYouTubeVideoId(url ?? '');
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div>
      <BlockContainer>
        <iframe
          className={loading ? 'invisible h-0' : ''}
          onLoad={() => setLoading(false)}
          width="100%"
          height="315"
          src={embedUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube video player"
        ></iframe>
      </BlockContainer>
    </div>
  );
};
